import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { useActiveClinic } from '../../../context/ClinicContext'
import { useClinicPlanSnapshot } from '../../subscriptions/hooks/useClinicPlanSnapshot'
import { useClinicSubscription } from '../../subscriptions/hooks/useClinicSubscription'

export default function ChairsPage() {
  const { activeClinicId } = useActiveClinic()

  const [chairs, setChairs] = useState([])
  const [name, setName] = useState('')
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState(null)

  const { data: planSnapshot } = useClinicPlanSnapshot(activeClinicId)
  const { subscription } = useClinicSubscription(activeClinicId)

  const maxChairs = planSnapshot?.plan?.maxChairs
  const chairsCount = planSnapshot?.usage?.chairsCount ?? 0

  const limitReached =
    maxChairs !== null &&
    maxChairs !== undefined &&
    chairsCount >= maxChairs

  const isReadOnly = subscription?.access?.isReadOnly
  const readOnlyReason = subscription?.access?.reason

  useEffect(() => {
    if (!activeClinicId || activeClinicId === 'ALL') return

    let cancelled = false

    async function load() {
      try {
        setLoading(true)
        const { data } = await axios.get('/api/chairs', {
          params: { clinicId: activeClinicId },
        })

        if (!cancelled) setChairs(data)
      } catch (err) {
        console.error(err)
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    load()

    return () => {
      cancelled = true
    }
  }, [activeClinicId])

  async function handleCreate() {
    try {
      setSaving(true)
      setError(null)

      await axios.post('/api/chairs', {
        clinicId: activeClinicId,
        name,
      })

      setName('')

      const { data } = await axios.get('/api/chairs', {
        params: { clinicId: activeClinicId },
      })
      setChairs(data)
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        'No se pudo crear la silla'

      setError(Array.isArray(message) ? message[0] : message)
    } finally {
      setSaving(false)
    }
  }

  return (
    <div style={{ padding: 20 }}>
      <h2 style={{ marginBottom: 16 }}>Sillas</h2>

      {isReadOnly && (
        <div
          style={{
            background: '#fff1f0',
            border: '1px solid #ffa39e',
            color: '#a8071a',
            borderRadius: 10,
            padding: '10px 12px',
            marginBottom: 16,
            fontWeight: 600,
          }}
        >
          {readOnlyReason || 'La clínica está en modo solo lectura.'}
        </div>
      )}

      {error && (
        <div
          style={{
            background: '#fff1f0',
            border: '1px solid #ffa39e',
            color: '#a8071a',
            borderRadius: 10,
            padding: '10px 12px',
            marginBottom: 16,
            fontWeight: 600,
          }}
        >
          {error}
        </div>
      )}

      <div
        style={{
          display: 'flex',
          gap: 8,
          marginBottom: 16,
        }}
      >
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Nombre de la silla"
          style={{
            padding: 10,
            borderRadius: 8,
            border: '1px solid #cbd5e1',
          }}
        />

        <button
          onClick={handleCreate}
          disabled={saving || limitReached || isReadOnly}
          style={{
            padding: '10px 16px',
            borderRadius: 8,
            border: 'none',
            background: saving || limitReached || isReadOnly ? '#cbd5e1' : '#2563eb',
            color: '#fff',
            cursor: saving || limitReached || isReadOnly ? 'not-allowed' : 'pointer',
          }}
        >
          {saving ? 'Guardando...' : 'Crear'}
        </button>
      </div>

      {limitReached && (
        <div
          style={{
            background: '#fff7e6',
            border: '1px solid #ffd591',
            color: '#874d00',
            borderRadius: 10,
            padding: '10px 12px',
            marginBottom: 16,
            fontWeight: 600,
          }}
        >
          Has alcanzado el límite de sillas de tu plan
        </div>
      )}

      {loading ? (
        <div>Cargando...</div>
      ) : (
        <div
          style={{
            display: 'grid',
            gap: 8,
          }}
        >
          {chairs.map((c) => (
            <div
              key={c.id}
              style={{
                padding: 12,
                borderRadius: 8,
                border: '1px solid #e5e7eb',
                background: '#fff',
              }}
            >
              {c.name}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}